import AddIcon from "@mui/icons-material/Add";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import PrintIcon from "@mui/icons-material/Print";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import { Backdrop, ButtonGroup, InputAdornment } from "@mui/material";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Snackbar from "@mui/material/Snackbar";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

import { createNewFiscalReceipt } from "../../services/requests/CreateNewReceipt";
import ReportDialog from "../admin_components/ReportDialog";
import {
    BasicPaymentTypes,
    CONSTANT_PAYMENT_METHODS,
    CONSTANT_PAYMENT_METHODS_DICT,
    DigitalBasicPaymentTypes,
    DiscountPaymentTypes,
    PaymentTypes,
} from "../constants";
import CashPicker from "./CashPicker";

export default function NewReceipt() {
    const { t } = useTranslation();
    const [organization, setOrganization] = useState({});
    const [taxesRates, setTaxesRates] = useState([]);
    const [newReceipt, setNewReceipt] = useState(null);
    const [isReceiptCreated, setIsReceiptCreated] = useState(false);
    const [card, setCard] = useState({});

    let navigate = useNavigate();

    const onSubmitCashRegister = (data) => {
        setCard(data.formData);
        setOrganization(data.organization);
        const taxes = data.organization?.cash_registers?.[0]?.taxes;
        const isWatPay = data?.organization?.wat_pay;
        setTaxesRates(
            taxes?.filter((el) => (isWatPay ? el.enabled : el.code === "_")) ||
                []
        );
    };

    const initialStateValue = {
        report: "",
        receipt: "",
        clientIDNO: "",
        clientName: "",
        clientAddress: "",
        productName: "",
        productAmount: "",
        productPrice: "",
        taxes: taxesRates?.map((a) => ({ ...a })),

        globalAdditionType: "",
        globalAdditionPercent: "",
        globalAdditionRate: "",

        globalDiscountType: "",
        globalDiscountPercent: "",
        globalDiscountRate: "",

        paymentsType: [
            {
                type: "",
                deposit: "0.00",
            },
        ],

        activity: [
            {
                productName: "",
                productAmount: "",
                productPrice: "",
                productDiscountType: "",
                productDiscountRate: "",
                productDiscountPercent: "",
                productAdditionType: "",
                productAdditionRate: "",
                productAdditionPercent: "",
                // productDiscount: '',
                productVAT: 0,
                productTax: { code: "", percent: 0, rate: 0 },
                productCost: "",
            },
        ],
    };
    const [state, setState] = useState(initialStateValue);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [error, setError] = useState({
        status: false,
        msg: "Error",
        code: 0,
    });
    const [client, setClient] = useState({
        clientPhone: "",
        clientEmail: "",
    });
    const [showQRBtn, setShowQRBtn] = useState(false);
    const [openQRDialog, setQRDialog] = useState(false);
    const [receiptUrl, setReceiptUrl] = useState("");
    const [balanceErrorOpen, setBalanceErrorOpen] = useState(false);

    const [showReceipt, setShowReceipt] = useState(false);
    const [loadingMevId, setLoadingMevId] = useState(false);

    const [mevID, setMevID] = useState("");

    const [totalCost, setTotalCost] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [totalAddition, setTotalAddition] = useState(0);

    const [totalTax, setTotalTax] = useState([]);
    const [totalTaxRate, setTotalTaxRate] = useState(0);

    const [clientMoney, setClientMoney] = useState(0);
    const [notPaidInCash, setNotPaidInCash] = useState(0);
    const [restMoney, setRestMoney] = useState(0);
    const [subtotal, setSubtotal] = useState(0);

    const [receiptView, setReceiptView] = useState(false);
    const [sameVAT, setSameVAT] = useState({});

    const hasMultiplePayments = state.paymentsType.length >= 2;

    const hasAdditionalPaymentType =
        hasMultiplePayments &&
        state.paymentsType.some(
            (payment) => !BasicPaymentTypes.includes(payment.type)
        );

    const hasActivity = !!state?.activity?.[0]?.productCost;

    const handleChangeClient = (event) => {
        setClient({
            ...client,
            [event.target.name]: event.target.value,
        });
    };

    function receiptValidation(t) {
        let err = [];

        if (card.address === "") {
            err.push(t("fe_valid_error_cash_re"));
        }
        state.activity.forEach((product) => {
            if (product.productName === "") {
                err.push(t("fe_valid_error_product_name"));
            }
            if (
                parseFloat(product.productPrice) === 0 ||
                product.productPrice === "NaN" ||
                product.productPrice === ""
            ) {
                err.push(t("fe_valid_error_product_price"));
            }
            if (
                product.productTax.rate === "NaN" ||
                product.productTax.rate === ""
            ) {
                err.push(t("fe_valid_error_product_tax"));
            }
            if (!product.productTax.code) {
                err.push(t("fe_valid_error_product_tax"));
            }
        });
        if (parseFloat(totalCost) === 0) {
            err.push(t("fe_valid_error_cost_0"));
        }
        if (
            state.paymentsType.length === 1 &&
            state.paymentsType[0].type === ""
        ) {
            err.push(t("fe_valid_error_not_choosed"));
        }
        // Calculate total of limited payment methods
        const limitedPaymentMethodsTotal = state.paymentsType.reduce(
            (sum, pt) => {
                const paymentMethod = CONSTANT_PAYMENT_METHODS_DICT[pt.type];
                if (paymentMethod?.limitToTotalPrice) {
                    return sum + (parseFloat(pt.deposit) || 0);
                }
                return sum;
            },
            0
        );

        // Check if sum of limited payment methods exceeds total price
        if (limitedPaymentMethodsTotal > parseFloat(totalCost)) {
            err.push(
                "Sum of limited payment methods cannot exceed total price"
            );
        }

        const hasCashPayment = state.paymentsType.some(
            (pt) => pt.type === PaymentTypes.CASH
        );

        state.paymentsType.forEach((pt) => {
            if (pt.type === "" || pt.productPrice === "NaN") {
                err.push(t("fe_valid_error_not_choosed_2"));
            }
            if (
                hasAdditionalPaymentType &&
                !hasCashPayment &&
                parseFloat(pt.deposit) >= parseFloat(totalCost)
            ) {
                err.push(t("fe_valid_error_exceeded_payment_types"));
            }
            // Check if payment method should be limited to total price
            const paymentMethod = CONSTANT_PAYMENT_METHODS_DICT[pt.type];
            if (
                paymentMethod?.limitToTotalPrice &&
                parseFloat(pt.deposit) > parseFloat(totalCost)
            ) {
                err.push(
                    `${paymentMethod.printName} amount cannot exceed total price`
                );
            }
        });

        // Calculate total of all payments
        const totalPayments = state.paymentsType.reduce((sum, pt) => {
            return sum + (parseFloat(pt.deposit) || 0);
        }, 0);

        // Check if total payments match total cost
        const paymentDifference = totalPayments - parseFloat(totalCost);
        if (paymentDifference < -0.01) {
            err.push(t("fe_valid_error_need_more_money"));
        } else if (
            paymentDifference > 0.01 &&
            state.paymentsType.length > 2 &&
            !hasCashPayment
        ) {
            err.push("Total payment exceeds the required amount");
        }

        return err;
    }

    useEffect(() => {
        let cost = 0;
        let individualDiscount = 0;
        let individualAddition = 0;

        const allTaxes = taxesRates.map((a) => ({ ...a }));
        let filteredTaxesDict = [];

        let totalCostAfterIndividual = 0;
        state.activity.forEach((product) => {
            const baseProductCost =
                parseFloat(product.productAmount || 0) *
                parseFloat(product.productPrice || 0);
            const productDiscount =
                parseFloat(product.productDiscountRate) || 0;
            const productAddition =
                parseFloat(product.productAdditionRate) || 0;
            const costAfterIndividual =
                baseProductCost - productDiscount + productAddition;
            totalCostAfterIndividual += Math.max(0, costAfterIndividual);
        });

        state.activity.forEach((product) => {
            const baseProductCost =
                parseFloat(product.productAmount || 0) *
                parseFloat(product.productPrice || 0);

            const productDiscount =
                parseFloat(product.productDiscountRate) || 0;
            const productAddition =
                parseFloat(product.productAdditionRate) || 0;

            let costAfterIndividual =
                baseProductCost - productDiscount + productAddition;
            costAfterIndividual = Math.max(0, costAfterIndividual);

            let globalDiscountForProduct = 0;
            if (state.globalDiscountType && totalCostAfterIndividual > 0) {
                if (
                    state.globalDiscountType === "percent" &&
                    state.globalDiscountPercent
                ) {
                    globalDiscountForProduct =
                        (costAfterIndividual *
                            parseFloat(state.globalDiscountPercent)) /
                        100;
                } else if (
                    state.globalDiscountType === "fix" &&
                    state.globalDiscountRate
                ) {
                    const productShare =
                        costAfterIndividual / totalCostAfterIndividual;
                    globalDiscountForProduct =
                        parseFloat(state.globalDiscountRate) * productShare;
                }
            }

            let globalAdditionForProduct = 0;
            if (state.globalAdditionType && totalCostAfterIndividual > 0) {
                if (
                    state.globalAdditionType === "percent" &&
                    state.globalAdditionPercent
                ) {
                    globalAdditionForProduct =
                        (costAfterIndividual *
                            parseFloat(state.globalAdditionPercent)) /
                        100;
                } else if (
                    state.globalAdditionType === "fix" &&
                    state.globalAdditionRate
                ) {
                    const productShare =
                        costAfterIndividual / totalCostAfterIndividual;
                    globalAdditionForProduct =
                        parseFloat(state.globalAdditionRate) * productShare;
                }
            }

            const finalProductCost = Math.max(
                0,
                costAfterIndividual -
                    globalDiscountForProduct +
                    globalAdditionForProduct
            );

            product.productCost = finalProductCost.toFixed(2);
            cost += finalProductCost;

            individualDiscount += productDiscount + globalDiscountForProduct;
            individualAddition += productAddition + globalAdditionForProduct;

            allTaxes.forEach((tax) => {
                if (tax.code === product.productTax.code) {
                    let rate =
                        (finalProductCost * tax.percent) / (100 + tax.percent);
                    tax.rate = rate.toFixed(2);
                    filteredTaxesDict[tax.code] = tax;
                    product.productVAT =
                        filteredTaxesDict[product.productTax.code]?.rate || "";
                }
            });
        });

        let finalCost = cost;
        finalCost = Math.max(finalCost, 0);

        if (finalCost || finalCost === 0) {
            setTotalCost(finalCost.toFixed(2));
        }

        if (individualDiscount) {
            setTotalDiscount(individualDiscount.toFixed(2));
        }

        if (individualAddition) {
            setTotalAddition(individualAddition.toFixed(2));
        }

        const filteredTaxes = Object.values(filteredTaxesDict).sort((a, b) =>
            a.code.localeCompare(b.code)
        );
        setTotalTax(filteredTaxes);

        const totalTaxRate = Object.values(sameVAT).reduce(
            (currentSum, vat) => {
                return parseFloat(currentSum) + parseFloat(vat.total);
            },
            0
        );

        setTotalTaxRate(totalTaxRate.toFixed(2));
        setReceiptView(false);
        setShowQRBtn(false);

        let notPaidInCash = 0;
        let clientMoney = 0;
        let subtotal = 0;
        let rest = 0;
        let totalOtherDeposits = 0;

        state.paymentsType.forEach((pt) => {
            if (!DigitalBasicPaymentTypes.includes(pt.type)) {
                totalOtherDeposits += parseFloat(pt.deposit);
            }
        });

        const hasCashSelected = state.paymentsType.some(
            (pt) => pt.type === PaymentTypes.CASH
        );

        state.paymentsType.forEach((pt) => {
            if (pt.type !== "") {
                if (pt.type === PaymentTypes.CASH) {
                    clientMoney = parseFloat(pt.deposit);
                } else if (DigitalBasicPaymentTypes.includes(pt.type)) {
                    const digitalBasicCount = state.paymentsType.filter((p) =>
                        DigitalBasicPaymentTypes.includes(p.type)
                    ).length;

                    if (digitalBasicCount === 1 && !hasCashSelected) {
                        pt.deposit = Math.max(
                            finalCost - totalOtherDeposits,
                            0
                        ).toFixed(2);
                    }
                    notPaidInCash = notPaidInCash + parseFloat(pt.deposit);
                } else {
                    notPaidInCash = notPaidInCash + parseFloat(pt.deposit);
                }
            }
        });

        if (finalCost) {
            if (notPaidInCash) {
                subtotal = Math.max(finalCost - notPaidInCash, 0);
            } else {
                subtotal = finalCost;
            }
        }

        state.paymentsType.forEach((pt) => {
            const { type } = pt;
            const hasDiscountType = DiscountPaymentTypes.includes(type);

            if (subtotal || !hasDiscountType) {
                rest = clientMoney - subtotal;
            }

            if (rest < 0 || isNaN(rest) || !type) {
                rest = 0;
            }
        });

        setClientMoney(clientMoney.toFixed(2));
        setRestMoney(rest.toFixed(2));
        setSubtotal(totalCostAfterIndividual.toFixed(2));
        setNotPaidInCash(notPaidInCash.toFixed(2));

        const totalBaseCost = calculateTotalCostAfterIndividual();
        if (
            state.globalDiscountType === "percent" &&
            state.globalDiscountPercent &&
            totalBaseCost > 0
        ) {
            const newGlobalDiscountRate = (
                (totalBaseCost * parseFloat(state.globalDiscountPercent)) /
                100
            ).toFixed(2);
            if (newGlobalDiscountRate !== state.globalDiscountRate) {
                setState((prev) => ({
                    ...prev,
                    globalDiscountRate: newGlobalDiscountRate,
                }));
            }
        }
        if (
            state.globalAdditionType === "percent" &&
            state.globalAdditionPercent &&
            totalBaseCost > 0
        ) {
            const newGlobalAdditionRate = (
                (totalBaseCost * parseFloat(state.globalAdditionPercent)) /
                100
            ).toFixed(2);
            if (newGlobalAdditionRate !== state.globalAdditionRate) {
                setState((prev) => ({
                    ...prev,
                    globalAdditionRate: newGlobalAdditionRate,
                }));
            }
        }
    }, [sameVAT, state, taxesRates]);

    useEffect(() => {
        let sameVAT = {};

        state.activity.forEach((product) => {
            const { productTax, productVAT } = product;

            if (productTax && productTax.code) {
                const taxCode = productTax.code;

                if (sameVAT.hasOwnProperty(taxCode)) {
                    sameVAT[taxCode].total += parseFloat(productVAT);
                    sameVAT[taxCode].total = parseFloat(
                        sameVAT[taxCode].total.toFixed(2)
                    );
                } else {
                    sameVAT[taxCode] = {
                        total: parseFloat(productVAT),
                    };
                }
            }
        });

        setSameVAT(sameVAT);
    }, [state]);

    useEffect(() => {
        if (!(mevID === "")) {
            setShowReceipt(true);
            setLoadingMevId(false);
            setOpenSuccess(true);
        }
    }, [mevID]);

    const handleSendReceipt = () => {
        let activities = [];
        const globalOthersField = [];

        if (state.globalAdditionType && state.globalAdditionRate) {
            globalOthersField.push({
                type: "1",
                percent: state.globalAdditionPercent.toString(),
                rate: state.globalAdditionRate.toString(),
            });
        }

        if (state.globalDiscountType && state.globalDiscountRate) {
            globalOthersField.push({
                type: "2",
                percent: state.globalDiscountPercent.toString(),
                rate: state.globalDiscountRate.toString(),
            });
        }

        state.activity.forEach((product) => {
            // Calculate base cost (amount * price) without any reductions
            const baseCost = (parseFloat(product.productAmount || 0) * parseFloat(product.productPrice || 0)).toFixed(2);

            // Calculate final cost after discounts/additions for tax calculation
            const discountRate = parseFloat(product.productDiscountRate) || 0;
            const additionRate = parseFloat(product.productAdditionRate) || 0;
            const finalCost = (parseFloat(baseCost) - discountRate + additionRate).toFixed(2);

            // Calculate tax rate based on final cost after discounts/additions
            const taxPercent = parseFloat(product.productTax.percent) || 0;
            const taxRate = ((parseFloat(finalCost) * taxPercent) / (100 + taxPercent)).toFixed(2);

            let activity = {
                amount: product.productAmount,
                price: product.productPrice,
                name: product.productName,
                cost: baseCost,
                finalCost: finalCost, // Used for taxes calculation
                tax: {
                    percent: product.productTax.percent.toString(),
                    code: product.productTax.code || "A",
                    rate: taxRate,
                },
            };

            if (product.productDiscountRate || product.productAdditionRate) {
                const others = { field: [] };

                if (product.productDiscountRate) {
                    others.field.push({
                        type: "2", //  discount
                        code: product.productTax.code,
                        percent: product.productDiscountPercent,
                        rate: product.productDiscountRate,
                    });
                }

                if (product.productAdditionRate) {
                    others.field.push({
                        type: "1", // addition
                        code: product.productTax.code,
                        percent: product.productAdditionPercent,
                        rate: product.productAdditionRate,
                    });
                }

                activity = {
                    ...activity,
                    others: others,
                };
            }

            activities.push(activity);
        });

        const sortedPayments = state?.paymentsType.sort(
            (a, b) => parseFloat(b.deposit) - parseFloat(a.deposit)
        );

        const taxesFieldObj = activities.reduce((acc, activity) => {
            const { tax } = activity;
            if (acc[tax.code]) {
                const { cost, rate } = acc[tax.code];
                acc[tax.code].cost = (
                    parseFloat(cost) + parseFloat(activity.finalCost)
                ).toString();
                acc[tax.code].rate = (
                    parseFloat(rate) + parseFloat(tax.rate)
                ).toString();
            } else {
                acc[tax.code] = {
                    code: tax.code,
                    percent: tax.percent,
                    rate: tax.rate,
                    cost: activity.finalCost,
                };
            }
            return acc;
        }, {});

        // Adjust taxes cost and rate to use total instead of subtotal
        // Apply proportional adjustment for global discounts/additions
        const subtotalValue = parseFloat(subtotal) || 0;
        const totalValue = parseFloat(totalCost) || 0;
        const adjustmentRatio = subtotalValue > 0 ? totalValue / subtotalValue : 1;

        const taxesField = Object.values(taxesFieldObj).map((taxItem) => ({
            ...taxItem,
            cost: (parseFloat(taxItem.cost) * adjustmentRatio).toFixed(2),
            rate: (parseFloat(taxItem.rate) * adjustmentRatio).toFixed(2),
        }));

        // Remove finalCost from activities before sending to API (it's only used for tax calculation)
        const activitiesForApi = activities.map(({ finalCost, ...rest }) => rest);

        let param = {
            soap_data: {
                card: {
                    ...card,
                },
                data: {
                    total: totalCost.toString(),
                    payments: {
                        field: sortedPayments,
                    },
                    change: restMoney.toString(),
                    subtotal: subtotal.toString(),
                },
                activities: {
                    field: activitiesForApi,
                    taxes: {
                        field: taxesField,
                    },
                    others: {
                        field: globalOthersField,
                    },
                },
            },
            email: client.clientEmail,
            phone: client.clientPhone,
        };

        setLoadingMevId(true);

        createNewFiscalReceipt(param)
            .then((data) => {
                if (data.data?.soap_response?.state === "SUCCESS") {
                    setIsReceiptCreated(true);
                    setMevID(data.data.soap_response.id);
                    setNewReceipt(data.data);
                    setShowQRBtn(true);
                    setReceiptUrl(data.data.sfs_url);
                } else {
                    setError({
                        status: true,
                        msg:
                            data.data.soap_response.errors ||
                            "There are errors while receipt generation",
                    });
                }
            })
            .catch((error) => {
                const data = error?.response?.data || {};
                const msg =
                    data.error || "There are errors while receipt generation";

                if (
                    msg.includes(
                        "Suma eliberata nu coincide cu soldul disponibil"
                    )
                ) {
                    setLoadingMevId(false);
                    setBalanceErrorOpen(true);
                } else {
                    setError({
                        status: true,
                        msg,
                        code: error?.response?.status,
                    });
                }
            });
    };

    const showQR = () => {
        setQRDialog(true);
    };

    const handleCloseQrDialog = () => {
        setQRDialog(false);
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setOpenSuccess(false);
        setError({
            status: false,
            msg: "Error",
        });
    };

    const handleViewReceipt = () => {
        let err = receiptValidation(t);

        if (parseFloat(totalCost) < parseFloat(notPaidInCash)) {
            setError({
                status: true,
                msg: t("total_cost_is_less_than_not_paid_in_cash"),
            });
            return;
        }

        if (err.length === 0) {
            setReceiptView(!receiptView);
        } else {
            setError({
                status: true,
                msg: err[0],
            });
        }
    };

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    function clickBackToCreation() {
        setReceiptView(false);
    }

    const calculateTotalCostAfterIndividual = () => {
        let totalCostAfterIndividual = 0;
        state.activity.forEach((product) => {
            const amount = parseFloat(product.productAmount) || 0;
            const price = parseFloat(product.productPrice) || 0;
            const baseProductCost = amount * price;
            const productDiscount =
                parseFloat(product.productDiscountRate) || 0;
            const productAddition =
                parseFloat(product.productAdditionRate) || 0;
            const costAfterIndividual =
                baseProductCost - productDiscount + productAddition;
            totalCostAfterIndividual += Math.max(0, costAfterIndividual);
        });
        return totalCostAfterIndividual;
    };

    const calcGlobalAdditionRate = (percent) => {
        const totalBaseCost = calculateTotalCostAfterIndividual();
        if (totalBaseCost <= 0) return "0.00";
        return ((totalBaseCost * parseFloat(percent)) / 100).toFixed(2);
    };

    const calcGlobalAdditionPercent = (rate) => {
        const totalBaseCost = calculateTotalCostAfterIndividual();
        if (totalBaseCost <= 0) return "0.00";
        return ((parseFloat(rate) * 100) / totalBaseCost).toFixed(2);
    };

    const calcGlobalDiscountRate = (percent) => {
        const totalBaseCost = calculateTotalCostAfterIndividual();
        if (totalBaseCost <= 0) return "0.00";
        return ((totalBaseCost * parseFloat(percent)) / 100).toFixed(2);
    };

    const calcGlobalDiscountPercent = (rate) => {
        const totalBaseCost = calculateTotalCostAfterIndividual();
        if (totalBaseCost <= 0) return "0.00";
        return ((parseFloat(rate) * 100) / totalBaseCost).toFixed(2);
    };

    const handleGlobalAdditionChange = (event) => {
        const { name, value } = event.target;
        const regexExpression = /^[0-9]*\.?[0-9]*$/;

        if (name === "globalAdditionType") {
            setState((prev) => ({
                ...prev,
                globalAdditionType: value,
                globalAdditionPercent: "",
                globalAdditionRate: "",
            }));
        } else if (
            (name === "globalAdditionPercent" ||
                name === "globalAdditionRate") &&
            (value === "" || value.match(regexExpression))
        ) {
            if (name === "globalAdditionPercent") {
                const formattedValue =
                    value === "" ? "" : handleFormatDecimal(value);
                const rate =
                    value === "" ? "" : calcGlobalAdditionRate(formattedValue);

                setState((prev) => ({
                    ...prev,
                    globalAdditionPercent: formattedValue,
                    globalAdditionRate: rate,
                }));
            } else {
                if (value === "") {
                    setState((prev) => ({
                        ...prev,
                        globalAdditionRate: "",
                        globalAdditionPercent: "",
                    }));
                } else {
                    const formattedValue = handleFormatDecimal(value);
                    const percent = calcGlobalAdditionPercent(formattedValue);
                    setState((prev) => ({
                        ...prev,
                        globalAdditionRate: formattedValue,
                        globalAdditionPercent: percent,
                    }));
                }
            }
        }
    };

    const handleGlobalDiscountChange = (event) => {
        const { name, value } = event.target;
        const regexExpression = /^[0-9]*\.?[0-9]*$/;

        if (name === "globalDiscountType") {
            setState((prev) => ({
                ...prev,
                globalDiscountType: value,
                globalDiscountPercent: "",
                globalDiscountRate: "",
            }));
        } else if (
            (name === "globalDiscountPercent" ||
                name === "globalDiscountRate") &&
            (value === "" || value.match(regexExpression))
        ) {
            if (name === "globalDiscountPercent") {
                const formattedValue =
                    value === "" ? "" : handleFormatDecimal(value);
                const rate =
                    value === "" ? "" : calcGlobalDiscountRate(formattedValue);

                setState((prev) => ({
                    ...prev,
                    globalDiscountPercent: formattedValue,
                    globalDiscountRate: rate,
                }));
            } else {
                if (value === "") {
                    setState((prev) => ({
                        ...prev,
                        globalDiscountRate: "",
                        globalDiscountPercent: "",
                    }));
                } else {
                    const formattedValue = handleFormatDecimal(value);
                    const percent = calcGlobalDiscountPercent(formattedValue);
                    setState((prev) => ({
                        ...prev,
                        globalDiscountRate: formattedValue,
                        globalDiscountPercent: percent,
                    }));
                }
            }
        }
    };

    const handleFormatDecimal = (value) => {
        let str = value.replace(".", "");
        let result = "";

        if (str.length <= 2) {
            let pad = "0.00";
            result = pad.substring(0, pad.length - str.length) + str;
        }
        if (str.length > 2) {
            let x_res =
                parseInt(str.substring(0, str.length - 2)).toString() +
                "." +
                str.substring(str.length - 2, str.length);
            result = x_res;
        }

        return result;
    };

    const isCashRegisterAvailable = !!Object.keys(card).length;

    const isSfsError = error.code === 450;
    const isZError = error.code === 460;

    return (
        <>
            {isZError && (
                <ReportDialog
                    message={error.msg}
                    setError={setError}
                    card={card}
                />
            )}
            {error.status && isSfsError ? (
                <Backdrop open={error.status} sx={{ zIndex: 99999 }}>
                    <Box
                        style={{
                            display: "flex",
                            width: 500,
                            alignItems: "center",
                            flexDirection: "column",
                            justifyContent: "center",
                            backgroundColor: "#fff",
                            padding: 16,
                            borderRadius: 5,
                        }}
                    >
                        <WarningAmberIcon color="error" sx={{ fontSize: 40 }} />
                        <p>{`${error.msg}`}</p>
                        <Button
                            onClick={() => setError({ status: false, msg: "" })}
                        >
                            {t("retry")}
                        </Button>
                    </Box>
                </Backdrop>
            ) : error.status && !isZError ? (
                <Snackbar
                    open={error.status}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <Alert
                        onClose={handleClose}
                        severity="error"
                        sx={{ width: "100%" }}
                    >
                        {error.msg}
                    </Alert>
                </Snackbar>
            ) : null}
            <Box
                sx={{
                    flexGrow: 1,
                    marginTop: 3,
                    marginLeft: 0,
                    marginBottom: 10,
                }}
            >
                {!receiptView && (
                    <>
                        <CashPicker onSubmit={onSubmitCashRegister} />
                        {isCashRegisterAvailable && (
                            <>
                                <Box sx={{ mt: 4, mb: 4 }}>
                                    <Grid
                                        container
                                        spacing={2}
                                        alignItems={"end"}
                                        sx={{ mb: 2 }}
                                    >
                                        <Grid item xs={5}>
                                            <Typography
                                                sx={{ fontSize: 24 }}
                                                color="pimary"
                                            >
                                                {t("adding_product")}:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <FormControl
                                                fullWidth
                                                variant="standard"
                                            >
                                                <InputLabel
                                                    htmlFor="global-addition-amount"
                                                    shrink={
                                                        state.globalAdditionType
                                                            ? true
                                                            : false
                                                    }
                                                >
                                                    {t("addition_amount_check")}
                                                </InputLabel>
                                                <Input
                                                    id="global-addition-amount"
                                                    name={
                                                        state.globalAdditionType ===
                                                        "percent"
                                                            ? "globalAdditionPercent"
                                                            : "globalAdditionRate"
                                                    }
                                                    endAdornment={
                                                        <InputAdornment
                                                            position={"end"}
                                                        >
                                                            <ButtonGroup
                                                                size={"small"}
                                                            >
                                                                <Button
                                                                    variant={
                                                                        state.globalAdditionType ===
                                                                        "percent"
                                                                            ? "contained"
                                                                            : "outlined"
                                                                    }
                                                                    onClick={() =>
                                                                        handleGlobalAdditionChange(
                                                                            {
                                                                                target: {
                                                                                    name: "globalAdditionType",
                                                                                    value: "percent",
                                                                                },
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    %
                                                                </Button>
                                                                <Button
                                                                    variant={
                                                                        state.globalAdditionType ===
                                                                        "fix"
                                                                            ? "contained"
                                                                            : "outlined"
                                                                    }
                                                                    onClick={() =>
                                                                        handleGlobalAdditionChange(
                                                                            {
                                                                                target: {
                                                                                    name: "globalAdditionType",
                                                                                    value: "fix",
                                                                                },
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    MDL
                                                                </Button>
                                                            </ButtonGroup>
                                                        </InputAdornment>
                                                    }
                                                    value={
                                                        state.globalAdditionType ===
                                                        "percent"
                                                            ? state.globalAdditionPercent
                                                            : state.globalAdditionRate
                                                    }
                                                    onChange={
                                                        handleGlobalAdditionChange
                                                    }
                                                    disabled={
                                                        !state.globalAdditionType
                                                    }
                                                />
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={3}>
                                            <FormControl
                                                fullWidth
                                                variant="standard"
                                            >
                                                <InputLabel
                                                    htmlFor="global-discount-amount"
                                                    shrink={
                                                        state.globalDiscountType
                                                            ? true
                                                            : false
                                                    }
                                                >
                                                    {t("discount_amount_check")}
                                                </InputLabel>
                                                <Input
                                                    id="global-discount-amount"
                                                    name={
                                                        state.globalDiscountType ===
                                                        "percent"
                                                            ? "globalDiscountPercent"
                                                            : "globalDiscountRate"
                                                    }
                                                    value={
                                                        state.globalDiscountType ===
                                                        "percent"
                                                            ? state.globalDiscountPercent
                                                            : state.globalDiscountRate
                                                    }
                                                    onChange={
                                                        handleGlobalDiscountChange
                                                    }
                                                    disabled={
                                                        !state.globalDiscountType
                                                    }
                                                    endAdornment={
                                                        <InputAdornment
                                                            position={"end"}
                                                        >
                                                            <ButtonGroup
                                                                size={"small"}
                                                            >
                                                                <Button
                                                                    variant={
                                                                        state.globalDiscountType ===
                                                                        "percent"
                                                                            ? "contained"
                                                                            : "outlined"
                                                                    }
                                                                    onClick={() =>
                                                                        handleGlobalDiscountChange(
                                                                            {
                                                                                target: {
                                                                                    name: "globalDiscountType",
                                                                                    value: "percent",
                                                                                },
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    %
                                                                </Button>
                                                                <Button
                                                                    variant={
                                                                        state.globalDiscountType ===
                                                                        "fix"
                                                                            ? "contained"
                                                                            : "outlined"
                                                                    }
                                                                    onClick={() =>
                                                                        handleGlobalDiscountChange(
                                                                            {
                                                                                target: {
                                                                                    name: "globalDiscountType",
                                                                                    value: "fix",
                                                                                },
                                                                            }
                                                                        )
                                                                    }
                                                                >
                                                                    MDL
                                                                </Button>
                                                            </ButtonGroup>
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {/* <div>
                                    end
                                </div> */}
                                <Products
                                    products={state.activity}
                                    setState={setState}
                                    taxesRates={taxesRates}
                                />
                            </>
                        )}
                        {hasActivity && (
                            <>
                                <Typography
                                    sx={{ fontSize: 24, marginTop: 6 }}
                                    color="pimary"
                                    gutterBottom
                                >
                                    {t("total")}:
                                </Typography>
                                <Grid container spacing={2} align="left">
                                    <Grid item xs={6}>
                                        <PaymentsTypes
                                            paymentsType={state.paymentsType}
                                            restMoney={restMoney}
                                            setState={setState}
                                            totalCost={totalCost}
                                        />
                                        <br />
                                        <br />
                                        <Button
                                            variant="outlined"
                                            sx={{
                                                visibility: !receiptView
                                                    ? "visible"
                                                    : "hidden",
                                            }}
                                            onClick={handleViewReceipt}
                                        >
                                            {t("go_to_payment_btn")}
                                        </Button>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Grid
                                            container
                                            spacing={2}
                                            align="left"
                                        >
                                            <Grid item xs={12}>
                                                {t("vat")}:
                                            </Grid>
                                            <Grid item xs={6}></Grid>
                                        </Grid>
                                        {!!totalTax &&
                                            totalTax?.map((tax, index) => {
                                                const isNoWat =
                                                    tax.code === "_";
                                                const {
                                                    code: taxCode,
                                                    percent,
                                                } = tax;
                                                const totalVAT =
                                                    sameVAT[
                                                        taxCode
                                                    ]?.total.toFixed(2) || 0;

                                                return (
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="left"
                                                        key={`tax_${tax.code}_${index}`}
                                                    >
                                                        {isNoWat ? (
                                                            <Grid item>
                                                                {t("no_vat")}
                                                            </Grid>
                                                        ) : (
                                                            <>
                                                                <Grid
                                                                    item
                                                                    xs={1}
                                                                >
                                                                    {tax.code}
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={5}
                                                                    style={{
                                                                        whiteSpace:
                                                                            "nowrap",
                                                                    }}
                                                                >
                                                                    {percent} %
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={4}
                                                                    align="right"
                                                                >
                                                                    {totalVAT}
                                                                </Grid>
                                                            </>
                                                        )}
                                                    </Grid>
                                                );
                                            })}

                                        {totalTaxRate > 0 && (
                                            <>
                                                <Grid
                                                    container
                                                    spacing={2}
                                                    align="left"
                                                >
                                                    <Grid item xs={10}>
                                                        <Divider
                                                            style={{
                                                                background:
                                                                    "black",
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        {t("vat_total")}
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}
                                                        align="right"
                                                    >
                                                        {totalTaxRate}
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )}
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Grid
                                            container
                                            spacing={2}
                                            align="left"
                                        >
                                            <Grid item xs={12}>
                                                {t("discount")}:
                                            </Grid>
                                            <Grid item xs={6}>
                                                {totalDiscount}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Grid
                                            container
                                            spacing={2}
                                            align="left"
                                        >
                                            <Grid item xs={12}>
                                                {t("addition")}:
                                            </Grid>
                                            <Grid item xs={6}>
                                                {totalAddition}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Grid
                                            container
                                            spacing={2}
                                            align="left"
                                        >
                                            <Grid item xs={12}>
                                                {t("total_2")}:
                                            </Grid>
                                            <Grid item xs={6}>
                                                {totalCost}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        )}
                    </>
                )}

                {receiptView && (
                    <>
                        {/* get client data and send receipt to mev */}
                        <br /> <br />
                        <Button
                            variant="text"
                            color="secondary"
                            onClick={() => {
                                clickBackToCreation();
                            }}
                            disabled={showReceipt || loadingMevId}
                        >
                            &#60; {t("back_to_receipt_creation_btn")}
                        </Button>
                        <Divider />
                        <Grid
                            container
                            spacing={30}
                            sx={{
                                visibility: receiptView ? "visible" : "hidden",
                            }}
                            align="left"
                        >
                            <Grid item xs={4}>
                                <Typography variant="h5" component="div">
                                    {t("buyer_data")}
                                </Typography>
                                <Divider />
                                <Typography
                                    sx={{ fontSize: 12 }}
                                    color="text.secondary"
                                    gutterBottom
                                >
                                    {t("helper_text_enter_email")}
                                </Typography>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    <InputLabel htmlFor="component-simple">
                                        {t("phone")}
                                    </InputLabel>
                                    <Input
                                        id="component-simple"
                                        value={client.clientPhone}
                                        onChange={(e) => {
                                            const raw = e.target.value;
                                            let cleaned = raw.replace(
                                                /[^0-9+]/g,
                                                ""
                                            );
                                            if (cleaned.includes("+")) {
                                                cleaned = cleaned.replace(
                                                    /\+/g,
                                                    ""
                                                );
                                                if (raw.startsWith("+")) {
                                                    cleaned = "+" + cleaned;
                                                }
                                            }
                                            handleChangeClient({
                                                target: {
                                                    value: cleaned,
                                                    name: "clientPhone",
                                                },
                                            });
                                        }}
                                        name="clientPhone"
                                        type="phone"
                                    />
                                </FormControl>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    <InputLabel htmlFor="component-simple">
                                        {t("email")}
                                    </InputLabel>
                                    <Input
                                        id="component-simple"
                                        value={client.clientEmail}
                                        onChange={handleChangeClient}
                                        name="clientEmail"
                                        type="email"
                                    />
                                </FormControl>
                                {!showReceipt && (
                                    <Button
                                        variant="outlined"
                                        sx={{ marginTop: 2, width: "100%" }}
                                        onClick={handleSendReceipt}
                                        disabled={
                                            loadingMevId || isReceiptCreated
                                        }
                                    >
                                        {isReceiptCreated
                                            ? t("success_creat_send")
                                            : t("creat_send")}
                                    </Button>
                                )}
                                {!showReceipt && loadingMevId && (
                                    <Button
                                        variant="outlined"
                                        sx={{ marginTop: 2, width: "100%" }}
                                        onClick={() => window.open("/client")}
                                    >
                                        {t("new_receipt_in_new_tab_btn")}
                                    </Button>
                                )}

                                <Button
                                    variant="outlined"
                                    sx={{
                                        marginTop: 2,
                                        width: "100%",
                                        visibility: showReceipt
                                            ? "visible"
                                            : "hidden",
                                    }}
                                    startIcon={<PrintIcon />}
                                    onClick={handlePrint}
                                    disabled={!showQRBtn && !showReceipt}
                                >
                                    {t("print_receipt")}
                                </Button>

                                <Button
                                    variant="outlined"
                                    sx={{
                                        marginTop: 2,
                                        width: "100%",
                                        visibility: showReceipt
                                            ? "visible"
                                            : "hidden",
                                    }}
                                    disabled={!showQRBtn && !showReceipt}
                                    onClick={showQR}
                                >
                                    {t("show_qr_btn")}
                                </Button>

                                <Button
                                    variant="outlined"
                                    sx={{
                                        marginTop: 2,
                                        width: "100%",
                                        visibility: showReceipt
                                            ? "visible"
                                            : "hidden",
                                    }}
                                    disabled={!showReceipt}
                                    onClick={() => {
                                        navigate(0);
                                    }}
                                >
                                    {t("new_receipt_btn")}
                                </Button>
                            </Grid>
                            <Grid item xs={8}>
                                {/* here receipt view*/}

                                {showReceipt && (
                                    <Card
                                        sx={{ width: 375 }}
                                        ref={componentRef}
                                    >
                                        <CardContent>
                                            <Typography
                                                key="organization.name"
                                                variant="h5"
                                                component="h5"
                                                color="text.secondary"
                                                align="center"
                                            >
                                                {organization.name}
                                            </Typography>
                                            <Typography
                                                key="organization.idno"
                                                sx={{ fontSize: 14 }}
                                                color="text.secondary"
                                                align="center"
                                                gutterBottom
                                            >
                                                COD FISCAL: {organization.idno}
                                            </Typography>
                                            <Typography
                                                key="organization.address"
                                                sx={{ fontSize: 14 }}
                                                color="text.secondary"
                                                align="center"
                                                gutterBottom
                                            >
                                                {card.address}
                                            </Typography>
                                            {/*<Grid*/}
                                            {/*	container*/}
                                            {/*	spacing={2}*/}
                                            {/*	align="left"*/}
                                            {/*>*/}
                                            {/*	<Grid item xs={8}>*/}
                                            {/*		<Typography*/}
                                            {/*			sx={{fontSize: 14}}*/}
                                            {/*			color="text.secondary"*/}
                                            {/*			gutterBottom*/}
                                            {/*		>*/}
                                            {/*			OPERATOR:*/}
                                            {/*		</Typography>*/}
                                            {/*	</Grid>*/}
                                            {/*	<Grid item xs={4} align="right">*/}
                                            {/*		<Typography*/}
                                            {/*			sx={{fontSize: 14}}*/}
                                            {/*			color="text.secondary"*/}
                                            {/*			gutterBottom*/}
                                            {/*		>*/}
                                            {/*			{card.point}*/}
                                            {/*		</Typography>*/}
                                            {/*	</Grid>*/}
                                            {/*</Grid>*/}

                                            {newReceipt?.activity_type ? (
                                                <Typography
                                                    key="activity_type"
                                                    sx={{ fontSize: 14 }}
                                                    color="text.secondary"
                                                    align="center"
                                                    gutterBottom
                                                >
                                                    {t(
                                                        `activity_${newReceipt?.activity_type}`
                                                    )}
                                                </Typography>
                                            ) : null}

                                            <Divider />
                                            {state.activity.map(
                                                (product, index) => {
                                                    const fullCost = (
                                                        parseFloat(
                                                            product.productPrice
                                                        ) *
                                                        parseFloat(
                                                            product.productAmount
                                                        )
                                                    ).toFixed(2);
                                                    return (
                                                        <div key={index}>
                                                            <Grid
                                                                container
                                                                spacing={2}
                                                                align="left"
                                                            >
                                                                <Grid
                                                                    item
                                                                    xs={5}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: 14,
                                                                        }}
                                                                        color="text.secondary"
                                                                        gutterBottom
                                                                    >
                                                                        {
                                                                            product.productName
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={2}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: 14,
                                                                        }}
                                                                        color="text.secondary"
                                                                        gutterBottom
                                                                    >
                                                                        {
                                                                            product.productAmount
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={1}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: 14,
                                                                        }}
                                                                        color="text.secondary"
                                                                        gutterBottom
                                                                    >
                                                                        X
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={4}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: 14,
                                                                            wordBreak:
                                                                                "break-all",
                                                                            textAlign:
                                                                                "right",
                                                                        }}
                                                                        color="text.secondary"
                                                                        gutterBottom
                                                                    >
                                                                        {
                                                                            product.productPrice
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid
                                                                container
                                                                spacing={2}
                                                                align="left"
                                                            >
                                                                <Grid
                                                                    item
                                                                    xs={5}
                                                                ></Grid>
                                                                <Grid
                                                                    item
                                                                    xs={2}
                                                                ></Grid>
                                                                <Grid
                                                                    item
                                                                    xs={1}
                                                                ></Grid>
                                                                <Grid
                                                                    item
                                                                    xs={3}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: 14,
                                                                            wordBreak:
                                                                                "break-all",
                                                                            textAlign:
                                                                                "right",
                                                                        }}
                                                                        color="text.secondary"
                                                                        gutterBottom
                                                                    >
                                                                        {
                                                                            fullCost
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid
                                                                    item
                                                                    xs={1}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            fontSize: 14,
                                                                        }}
                                                                        color="text.secondary"
                                                                        gutterBottom
                                                                    >
                                                                        {
                                                                            product
                                                                                .productTax
                                                                                .code
                                                                        }
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                            {product?.productDiscountRate >
                                                                0 && (
                                                                <Grid
                                                                    container
                                                                    spacing={2}
                                                                    align="left"
                                                                >
                                                                    <Grid
                                                                        item
                                                                        xs={6}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 14,
                                                                            }}
                                                                            color="text.secondary"
                                                                            gutterBottom
                                                                        >
                                                                            Reducere
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={3}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 14,
                                                                            }}
                                                                            color="text.secondary"
                                                                            gutterBottom
                                                                        >
                                                                            {
                                                                                product?.productDiscountPercent
                                                                            }{" "}
                                                                            %
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={3}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 14,
                                                                            }}
                                                                            color="text.secondary"
                                                                            gutterBottom
                                                                        >
                                                                            {
                                                                                product?.productDiscountRate
                                                                            }
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            )}
                                                            {product?.productAdditionRate >
                                                                0 && (
                                                                <Grid
                                                                    container
                                                                    spacing={2}
                                                                    align="left"
                                                                >
                                                                    <Grid
                                                                        item
                                                                        xs={6}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 14,
                                                                            }}
                                                                            color="text.secondary"
                                                                            gutterBottom
                                                                        >
                                                                            Adaos
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={3}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 14,
                                                                            }}
                                                                            color="text.secondary"
                                                                            gutterBottom
                                                                        >
                                                                            {
                                                                                product?.productAdditionPercent
                                                                            }{" "}
                                                                            %
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={3}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 14,
                                                                            }}
                                                                            color="text.secondary"
                                                                            gutterBottom
                                                                        >
                                                                            {
                                                                                product?.productAdditionRate
                                                                            }
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            )}
                                                        </div>
                                                    );
                                                }
                                            )}

                                            <Divider />
                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={4}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        SUBTOTAL:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 14,
                                                            wordBreak:
                                                                "break-all",
                                                            textAlign: "right",
                                                        }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        {subtotal}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            {parseFloat(
                                                state.globalAdditionRate
                                            ) > 0 && (
                                                <>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="left"
                                                    >
                                                        <Grid item xs={4}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                    fontWeight: 500,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                Adaos
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {state.globalAdditionType ===
                                                                "percent"
                                                                    ? `${state.globalAdditionPercent} %`
                                                                    : ""}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                    wordBreak:
                                                                        "break-all",
                                                                    textAlign:
                                                                        "right",
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {
                                                                    state.globalAdditionRate
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}

                                            {parseFloat(
                                                state.globalDiscountRate
                                            ) > 0 && (
                                                <>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="left"
                                                    >
                                                        <Grid item xs={4}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                    fontWeight: 500,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                Reducere
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {state.globalDiscountType ===
                                                                "percent"
                                                                    ? `${state.globalDiscountPercent} %`
                                                                    : ""}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={5}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                    wordBreak:
                                                                        "break-all",
                                                                    textAlign:
                                                                        "right",
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {
                                                                    state.globalDiscountRate
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}

                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={4}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 14,
                                                            fontWeight: 600,
                                                        }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        TOTAL:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 14,
                                                            fontWeight: 600,
                                                            wordBreak:
                                                                "break-all",
                                                            textAlign: "right",
                                                        }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        {totalCost}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Divider />

                                            {totalTax?.map((tax, index) => {
                                                const isNoWat =
                                                    tax.code === "_";
                                                const taxCode = tax.code;
                                                const totalVAT =
                                                    sameVAT[
                                                        taxCode
                                                    ]?.total.toFixed(2) || 0;
                                                return (
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="left"
                                                        key={index}
                                                    >
                                                        <Grid item xs={4}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {isNoWat
                                                                    ? ""
                                                                    : `TVA ${tax.code} `}
                                                                {tax.code ===
                                                                    "F" ||
                                                                tax.code === "_"
                                                                    ? "Fără TVA"
                                                                    : `${tax.percent} %`}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                    wordBreak:
                                                                        "break-all",
                                                                    textAlign:
                                                                        "right",
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {totalVAT}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                );
                                            })}
                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={4}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        TVA TOTAL:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 14,
                                                            wordBreak:
                                                                "break-all",
                                                            textAlign: "right",
                                                        }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        {totalTaxRate}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Divider />

                                            {CONSTANT_PAYMENT_METHODS.map(
                                                (cpt) => {
                                                    if (cpt.type !== "1") {
                                                        let cpt_type = cpt.type;
                                                        let deposit = "";
                                                        state.paymentsType.map(
                                                            (pt) => {
                                                                if (
                                                                    pt.type ===
                                                                    cpt_type
                                                                ) {
                                                                    deposit =
                                                                        pt.deposit;
                                                                }
                                                            }
                                                        );
                                                        if (deposit !== "") {
                                                            return (
                                                                <Grid
                                                                    container
                                                                    spacing={2}
                                                                    align="left"
                                                                >
                                                                    <Grid
                                                                        item
                                                                        xs={4}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 14,
                                                                            }}
                                                                            color="text.secondary"
                                                                            gutterBottom
                                                                        >
                                                                            {
                                                                                cpt.printName
                                                                            }
                                                                            :
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid
                                                                        item
                                                                        xs={8}
                                                                    >
                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 14,
                                                                                wordBreak:
                                                                                    "break-all",
                                                                                textAlign:
                                                                                    "right",
                                                                            }}
                                                                            color="text.secondary"
                                                                            gutterBottom
                                                                        >
                                                                            {
                                                                                deposit
                                                                            }
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            );
                                                        }
                                                    }
                                                }
                                            )}

                                            {state.paymentsType.some(
                                                (pt) =>
                                                    pt.type ===
                                                    PaymentTypes.CASH
                                            ) && (
                                                <>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="left"
                                                    >
                                                        <Grid item xs={4}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                NUMERAR:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                    wordBreak:
                                                                        "break-all",
                                                                    textAlign:
                                                                        "right",
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {clientMoney}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="left"
                                                    >
                                                        <Grid item xs={4}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                REST:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                    wordBreak:
                                                                        "break-all",
                                                                    textAlign:
                                                                        "right",
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {restMoney}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}
                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={4}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        Articole:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: 14,
                                                            wordBreak:
                                                                "break-all",
                                                            textAlign: "right",
                                                        }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        {state.activity.length.toFixed(
                                                            3
                                                        )}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Divider />
                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={8}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        DATA:{" "}
                                                        {
                                                            newReceipt?.soap_data?.datetime?.split(
                                                                "T"
                                                            )[0]
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                        align="right"
                                                    >
                                                        ORA:{" "}
                                                        {
                                                            newReceipt?.soap_data?.datetime?.split(
                                                                "T"
                                                            )[1]
                                                        }
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            {newReceipt?.soap_data?.receipt && (
                                                <>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="left"
                                                    >
                                                        <Grid item xs={8}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                BON FISCAL:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                                align="right"
                                                            >
                                                                №:{" "}
                                                                {
                                                                    newReceipt
                                                                        .soap_data
                                                                        .receipt
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="left"
                                                    >
                                                        <Grid item xs={9}>
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                NUMARUL DE
                                                                IDENTIFICARE:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={3}
                                                            align="right"
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    fontSize: 14,
                                                                }}
                                                                color="text.secondary"
                                                                gutterBottom
                                                            >
                                                                {
                                                                    newReceipt
                                                                        ?.soap_data
                                                                        .id
                                                                }
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                            )}

                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={6}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        Casier:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                        align="right"
                                                    >
                                                        {
                                                            newReceipt?.user
                                                                ?.login
                                                        }
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={6}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        MEV ID:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                        align="right"
                                                    >
                                                        {mevID}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={8}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        DATA MEV:{" "}
                                                        {
                                                            newReceipt?.soap_response?.datetime?.split(
                                                                "T"
                                                            )[0]
                                                        }
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                        align="right"
                                                    >
                                                        ORA MEV:{" "}
                                                        {
                                                            newReceipt?.soap_response?.datetime?.split(
                                                                "T"
                                                            )[1]
                                                        }
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Divider />

                                            {showQRBtn && (
                                                <>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        align="center"
                                                    >
                                                        <Grid
                                                            item
                                                            xs={12}
                                                        ></Grid>
                                                        <Grid item xs={12}>
                                                            <div id="qrcode">
                                                                {receiptUrl && (
                                                                    <QRCode
                                                                        size={
                                                                            80
                                                                        }
                                                                        value={
                                                                            receiptUrl
                                                                        }
                                                                    />
                                                                )}
                                                            </div>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                        ></Grid>
                                                    </Grid>
                                                    <Divider />
                                                </>
                                            )}
                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={8}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        NUMARUL DE INREGISTRARE:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} align="right">
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        {card.number}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                spacing={2}
                                                align="left"
                                            >
                                                <Grid item xs={8}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        SN:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={4} align="right">
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        {card.factory}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            <Grid
                                                container
                                                spacing={2}
                                                align="center"
                                            >
                                                <Grid item xs={12}>
                                                    <Typography
                                                        sx={{ fontSize: 14 }}
                                                        color="text.secondary"
                                                        gutterBottom
                                                    >
                                                        *** BON FISCAL ***
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </CardContent>
                                    </Card>
                                )}

                                {!showReceipt && loadingMevId && (
                                    <Card
                                        sx={{ width: 375 }}
                                        ref={componentRef}
                                    >
                                        <div align="center">
                                            <CircularProgress
                                                sx={{
                                                    marginTop: 4,
                                                    marginBottom: 4,
                                                }}
                                            />
                                        </div>
                                    </Card>
                                )}
                            </Grid>
                        </Grid>
                    </>
                )}

                <Snackbar
                    open={openSuccess}
                    autoHideDuration={6000}
                    onClose={handleClose}
                >
                    <Alert
                        onClose={handleClose}
                        severity="success"
                        sx={{ width: "100%" }}
                    >
                        {t("receipt_created_msg")}
                    </Alert>
                </Snackbar>
                <Dialog
                    open={openQRDialog}
                    onClose={handleCloseQrDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("qr_code_description")}
                    </DialogTitle>
                    <DialogContent>
                        <div id="qrcode">
                            <QRCode value={receiptUrl} />
                        </div>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={balanceErrorOpen}
                    onClose={() => setBalanceErrorOpen(false)}
                    aria-labelledby="balance-error-dialog-title"
                >
                    <DialogTitle id="balance-error-dialog-title">
                        {t("balance_error_title")}
                    </DialogTitle>
                    <DialogActions
                        sx={{ flexDirection: "column", gap: 1, p: 2 }}
                    >
                        <Button
                            variant="outlined"
                            fullWidth
                            color="success"
                            onClick={() => {
                                setBalanceErrorOpen(false);
                                window.open(
                                    `/acps/new-service-receipt?rid=${organization?.cash_registers?.[0]?._id}`,
                                    "_blank"
                                );
                            }}
                        >
                            {t("add_cash_to_register")}
                        </Button>
                        <Button
                            variant="outlined"
                            fullWidth
                            color="warning"
                            onClick={() => {
                                setBalanceErrorOpen(false);
                            }}
                        >
                            {t("change_payment_method")}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </>
    );
}

function Products(props) {
    // const { t } = useTranslation();
    const { t } = useTranslation(); // remove later
    let { taxesRates, products } = props;

    function addProduct() {
        products.push({
            productName: "",
            productAmount: "",
            productPrice: "",
            productDiscount: "",
            productDiscountType: "",
            productDiscountPercent: "",
            productDiscountRate: "",
            productAdditionType: "",
            productAdditionRate: "",
            productAdditionPercent: "",
            productVAT: 0,
            productTax: { code: "", percent: 0, rate: 0 },
            productCost: "",
        });
        props.setState((prev) => {
            return {
                ...prev,
                activity: products,
            };
        });
    }

    function delProduct(index) {
        // delete cargo[index];
        products.splice(index, 1);
        props.setState((prev) => {
            return {
                ...prev,
                activity: products,
            };
        });
    }

    const handleChangeAmount = (amount) => {
        const formattedAmount = parseFloat(amount).toFixed(3);
        let str = formattedAmount.replace(".", "");
        let result = "";
        if (str.length <= 3) {
            let pad = "0.000";
            result = pad.substring(0, pad.length - str.length) + str;
        }
        if (str.length > 3) {
            let x_res =
                parseInt(str.substring(0, str.length - 3)).toString() +
                "." +
                str.substring(str.length - 3, str.length);
            result = x_res;
        }
        return result;
    };

    const handleChangePrice = (price) => {
        let str = price.replace(".", "");
        let result = "";
        if (str.length <= 2) {
            let pad = "0.00";
            result = pad.substring(0, pad.length - str.length) + str;
        }
        if (str.length > 2) {
            let x_res =
                parseInt(str.substring(0, str.length - 2)).toString() +
                "." +
                str.substring(str.length - 2, str.length);
            result = x_res;
        }
        return result;
    };

    const handleChangeName = (oldName, newName) => {
        var ru = /[а-яё]+/i.test(newName);
        if (ru) {
            alert("Use only latin litteres!");
            return oldName;
        }
        return newName;
    };

    const handleChangeDiscount = (value) => {
        let str = value.replace(".", "");
        let result = "";

        if (str.length <= 2) {
            let pad = "0.00";
            result = pad.substring(0, pad.length - str.length) + str;
        }
        if (str.length > 2) {
            let x_res =
                parseInt(str.substring(0, str.length - 2)).toString() +
                "." +
                str.substring(str.length - 2, str.length);
            result = x_res;
        }

        return result;
    };

    const handleChangeAddition = (value) => {
        let str = value.replace(".", "");
        let result = "";

        if (str.length <= 2) {
            let pad = "0.00";
            result = pad.substring(0, pad.length - str.length) + str;
        }
        if (str.length > 2) {
            let x_res =
                parseInt(str.substring(0, str.length - 2)).toString() +
                "." +
                str.substring(str.length - 2, str.length);
            result = x_res;
        }

        return result;
    };

    const calcAdditionRate = (amount, price, percent) => {
        return parseFloat((amount * price * percent) / 100).toFixed(2);
    };

    const calcAdditionPercent = (amount, price, value) => {
        return parseFloat((value * 100) / (amount * price)).toFixed(2);
    };

    const calcDiscountRate = (amount, price, percent) => {
        return parseFloat((amount * price * percent) / 100).toFixed(2);
    };
    const calcDiscountPercent = (amount, price, value) => {
        return parseFloat((value * 100) / (amount * price)).toFixed(2);
    };

    function handleChange(event, index, amountBlur = false) {
        let changebleProduct = products[index];
        const regexExpression = /^[0-9]*(\.){0,1}[0-9]*$/g;
        const name = event.target.name;
        const value = event.target.value;
        if (name === "productAmount" && value.match(regexExpression)) {
            if (amountBlur && value) {
                changebleProduct[name] = handleChangeAmount(value);
            } else {
                changebleProduct[name] = value;
            }
        }
        if (name === "productPrice" && value.match(regexExpression)) {
            changebleProduct[name] = handleChangePrice(value);
        }
        if (name === "productName") {
            changebleProduct[name] = handleChangeName(
                changebleProduct[name],
                value
            );
        }

        if (name === "productTax") {
            changebleProduct[name] = value;
        }

        if (name === "productAdditionType") {
            changebleProduct[name] = value;
        }

        if (name === "productAdditionPercent") {
            changebleProduct[name] = handleChangeAddition(value);
            changebleProduct["productAdditionRate"] = calcAdditionRate(
                changebleProduct.productAmount,
                changebleProduct.productPrice,
                handleChangeAddition(value)
            );
        }

        if (name === "productAdditionRate") {
            changebleProduct[name] = handleChangeAddition(value);
            changebleProduct["productAdditionPercent"] = calcAdditionPercent(
                changebleProduct.productAmount,
                changebleProduct.productPrice,
                handleChangeAddition(value)
            );
        }

        if (name === "productDiscountType") {
            changebleProduct[name] = value;
        }

        if (name === "productDiscountPercent") {
            changebleProduct[name] = handleChangeDiscount(value);
            changebleProduct["productDiscountRate"] = calcDiscountRate(
                changebleProduct.productAmount,
                changebleProduct.productPrice,
                handleChangeDiscount(value)
            );
        }
        if (name === "productDiscountRate") {
            changebleProduct[name] = handleChangeDiscount(value);
            changebleProduct["productDiscountPercent"] = calcDiscountPercent(
                changebleProduct.productAmount,
                changebleProduct.productPrice,
                handleChangeDiscount(value)
            );
        }

        if (
            changebleProduct.productAmount !== "" &&
            changebleProduct.productPrice !== ""
        ) {
            let amount = parseFloat(changebleProduct.productAmount);
            let price = parseFloat(changebleProduct.productPrice);
            let discount_type = changebleProduct.productDiscountType;
            let discount_percent =
                parseFloat(changebleProduct.productDiscountPercent) || 0;
            let discount_rate =
                parseFloat(changebleProduct.productDiscountRate) || 0;
            let discount = 0;
            if (discount_type === "percent") {
                discount = calcDiscountRate(amount, price, discount_percent);
                changebleProduct["productDiscountRate"] = calcDiscountRate(
                    amount,
                    price,
                    discount_percent
                );
            } else {
                discount = discount_rate;
            }

            let addition_type = changebleProduct.productAdditionType;
            let addition_percent =
                parseFloat(changebleProduct.productAdditionPercent) || 0;
            let addition_rate =
                parseFloat(changebleProduct.productAdditionRate) || 0;
            let addition = 0;

            if (addition_type === "percent") {
                addition = parseFloat(
                    calcAdditionRate(amount, price, addition_percent)
                );
                changebleProduct["productAdditionRate"] = calcAdditionRate(
                    amount,
                    price,
                    addition_percent
                );
            } else {
                addition = addition_rate || 0;
            }

            discount = isNaN(discount) ? 0 : parseFloat(discount);
            addition = isNaN(addition) ? 0 : parseFloat(addition);

            let cost = amount * price - discount + addition;
            changebleProduct.productCost = cost.toFixed(2);
        }

        products[index] = changebleProduct;
        props.setState((prev) => {
            return {
                ...prev,
                activity: products,
            };
        });
    }

    return (
        <div>
            {products.map((product, index) => {
                return (
                    <div key={`product_${index}`}>
                        <Grid container spacing={2} align="left">
                            <Grid item xs={2}>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    <InputLabel htmlFor="component-simple">
                                        {t("product_name")}
                                    </InputLabel>
                                    <Input
                                        id="component-simple"
                                        value={product.productName}
                                        onChange={(event) =>
                                            handleChange(event, index)
                                        }
                                        name="productName"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={1}>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    <InputLabel htmlFor="component-simple">
                                        {t("product_amount")}
                                    </InputLabel>
                                    <Input
                                        id="component-simple"
                                        value={product.productAmount}
                                        onBlur={(event) =>
                                            handleChange(event, index, true)
                                        }
                                        onChange={(event) =>
                                            handleChange(event, index)
                                        }
                                        name="productAmount"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={1}>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    <InputLabel htmlFor="component-simple">
                                        {t("product_price")}
                                    </InputLabel>
                                    <Input
                                        id="component-simple"
                                        value={product.productPrice}
                                        onChange={(event) =>
                                            handleChange(event, index)
                                        }
                                        name="productPrice"
                                    />
                                </FormControl>
                            </Grid>

                            <Grid item xs={1}>
                                <TextField
                                    select
                                    label={t("tax")}
                                    name="productTax"
                                    value={
                                        product.productTax._id
                                            ? product.productTax
                                            : null
                                    }
                                    onChange={(event) =>
                                        handleChange(event, index)
                                    }
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    {taxesRates?.map((option, index) => (
                                        <MenuItem
                                            key={`tax_${index}`}
                                            value={option}
                                        >
                                            {option.code === "_"
                                                ? t("no_vat")
                                                : `${option.code} ${option.percent}%`}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>

                            <Grid item xs={2.5}>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    <InputLabel
                                        htmlFor="component-addition"
                                        shrink={
                                            product.productAdditionType
                                                ? true
                                                : false
                                        }
                                    >
                                        {t("addition_amount")}
                                    </InputLabel>
                                    <Input
                                        id="component-addition"
                                        value={
                                            product.productAdditionType ===
                                            "percent"
                                                ? product.productAdditionPercent
                                                : product.productAdditionRate
                                        }
                                        onChange={(event) =>
                                            handleChange(event, index)
                                        }
                                        name={
                                            product.productAdditionType ===
                                            "percent"
                                                ? "productAdditionPercent"
                                                : "productAdditionRate"
                                        }
                                        endAdornment={
                                            <InputAdornment position={"end"}>
                                                <ButtonGroup size={"small"}>
                                                    <Button
                                                        variant={
                                                            product.productAdditionType ===
                                                            "percent"
                                                                ? "contained"
                                                                : "outlined"
                                                        }
                                                        onClick={() =>
                                                            handleChange(
                                                                {
                                                                    target: {
                                                                        name: "productAdditionType",
                                                                        value: "percent",
                                                                    },
                                                                },
                                                                index
                                                            )
                                                        }
                                                    >
                                                        %
                                                    </Button>
                                                    <Button
                                                        variant={
                                                            product.productAdditionType ===
                                                            "fix"
                                                                ? "contained"
                                                                : "outlined"
                                                        }
                                                        onClick={() =>
                                                            handleChange(
                                                                {
                                                                    target: {
                                                                        name: "productAdditionType",
                                                                        value: "fix",
                                                                    },
                                                                },
                                                                index
                                                            )
                                                        }
                                                    >
                                                        MDL
                                                    </Button>
                                                </ButtonGroup>
                                            </InputAdornment>
                                        }
                                        disabled={
                                            product.productAdditionType === ""
                                        }
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={2.5}>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    <InputLabel
                                        htmlFor="component-discount"
                                        shrink={
                                            product.productDiscountType
                                                ? true
                                                : false
                                        }
                                        error={
                                            !!(product.productDiscountType ===
                                            "percent"
                                                ? product.productDiscountPercent
                                                : product.productDiscountRate) &&
                                            parseFloat(product.productCost) <= 0
                                        }
                                    >
                                        {t("discount_amount")}
                                    </InputLabel>
                                    <Input
                                        fullWidth
                                        id="component-discount"
                                        value={
                                            product.productDiscountType ===
                                            "percent"
                                                ? product.productDiscountPercent
                                                : product.productDiscountRate
                                        }
                                        onChange={(event) =>
                                            handleChange(event, index)
                                        }
                                        endAdornment={
                                            <InputAdornment position={"end"}>
                                                <ButtonGroup size={"small"}>
                                                    <Button
                                                        variant={
                                                            product.productDiscountType ===
                                                            "percent"
                                                                ? "contained"
                                                                : "outlined"
                                                        }
                                                        onClick={() =>
                                                            handleChange(
                                                                {
                                                                    target: {
                                                                        name: "productDiscountType",
                                                                        value: "percent",
                                                                    },
                                                                },
                                                                index
                                                            )
                                                        }
                                                    >
                                                        %
                                                    </Button>
                                                    <Button
                                                        variant={
                                                            product.productDiscountType ===
                                                            "fix"
                                                                ? "contained"
                                                                : "outlined"
                                                        }
                                                        onClick={() =>
                                                            handleChange(
                                                                {
                                                                    target: {
                                                                        name: "productDiscountType",
                                                                        value: "fix",
                                                                    },
                                                                },
                                                                index
                                                            )
                                                        }
                                                    >
                                                        MDL
                                                    </Button>
                                                </ButtonGroup>
                                            </InputAdornment>
                                        }
                                        name={
                                            product.productDiscountType ===
                                            "percent"
                                                ? "productDiscountPercent"
                                                : "productDiscountRate"
                                        }
                                        disabled={
                                            product.productDiscountType === ""
                                        }
                                        error={
                                            !!(product.productDiscountType ===
                                            "percent"
                                                ? product.productDiscountPercent
                                                : product.productDiscountRate) &&
                                            parseFloat(product.productCost) <=
                                                0.0
                                        }
                                    />
                                    {
                                        !(product.productDiscountType ===
                                        "percent"
                                            ? product.productDiscountPercent
                                            : product.productDiscountRate)
                                    }
                                </FormControl>
                            </Grid>

                            <Grid item xs={1}>
                                <FormControl
                                    fullWidth
                                    sx={{ m: 1 }}
                                    variant="standard"
                                >
                                    <InputLabel htmlFor="component-simple">
                                        {t("amount")}
                                    </InputLabel>
                                    <Input
                                        id="component-simple"
                                        value={product.productCost}
                                        name="cost"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={1} align="center">
                                <IconButton
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    size="small"
                                    sx={{ marginTop: 3 }}
                                    onClick={() => delProduct(index)}
                                    style={{
                                        visibility:
                                            props.products.length > 1
                                                ? "visible"
                                                : "hidden",
                                    }}
                                >
                                    <DeleteForeverOutlinedIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </div>
                );
            })}
            <Button
                variant="outlined"
                startIcon={<AddIcon />}
                sx={{ marginTop: 2 }}
                onClick={() => addProduct()}
            >
                {t("add_product")}
            </Button>
        </div>
    );
}

function PaymentsTypes(props) {
    const { t } = useTranslation();
    let paymentsType = props.paymentsType;
    let restMoney = props.restMoney;

    const getAvailablePaymentMethods = (currentIndex) => {
        const hasOtherMethodsSelected = paymentsType.some(
            (pt, index) =>
                index !== currentIndex &&
                pt.type !== "" &&
                pt.type !== PaymentTypes.FOOD_COUPON
        );

        return CONSTANT_PAYMENT_METHODS.filter((paymentMethod) => {
            if (paymentsType[currentIndex]?.type === paymentMethod.type) {
                return true;
            }

            if (
                hasOtherMethodsSelected &&
                paymentMethod.type === PaymentTypes.FOOD_COUPON
            ) {
                return false;
            }

            return !paymentsType.some(
                (pt, index) =>
                    index !== currentIndex && pt.type === paymentMethod.type
            );
        });
    };

    function addPaymentsMethod() {
        let allowed = true;
        paymentsType.forEach((pt) => {
            if (pt.type === "") {
                allowed = false;
            }
        });
        if (allowed) {
            paymentsType.push({
                type: "",
                deposit: "0.00",
            });
            props.setState((prev) => {
                return {
                    ...prev,
                    paymentsType: paymentsType,
                };
            });
        }
    }

    function handleChangePaymentMethodType(event, index) {
        let changed = {
            type: event.target.value,
            deposit: "0.00",
        };
        paymentsType[index] = changed;

        if (event.target.value === PaymentTypes.CASH) {
            paymentsType.forEach((pt) => {
                if (DigitalBasicPaymentTypes.includes(pt.type)) {
                    pt.deposit = "0.00";
                }
            });
        }

        props.setState((prev) => {
            return {
                ...prev,
                paymentsType: paymentsType,
            };
        });
    }

    function delPaymentsMethod(index) {
        paymentsType.splice(index, 1);
        props.setState((prev) => {
            return {
                ...prev,
                paymentsType: paymentsType,
            };
        });
    }

    function validate(s) {
        var rgx = /^[0-9]*\.?[0-9]*$/;
        return s.match(rgx);
    }

    const handleChangePaymentMoney = (event, index) => {
        if (paymentsType[index].type !== "") {
            if (validate(event.target.value)) {
                let str = event.target.value.replace(".", "");
                let result = "";

                if (str.length <= 2) {
                    let pad = "0.00";
                    result = pad.substring(0, pad.length - str.length) + str;
                }
                if (str.length > 2) {
                    let x_res =
                        parseInt(str.substring(0, str.length - 2)).toString() +
                        "." +
                        str.substring(str.length - 2, str.length);
                    result = x_res;
                }

                const paymentMethod =
                    CONSTANT_PAYMENT_METHODS_DICT[paymentsType[index].type];
                if (paymentMethod?.limitToTotalPrice) {
                    const totalCost = parseFloat(props.totalCost || 0);
                    const enteredAmount = parseFloat(result);

                    if (enteredAmount > totalCost) {
                        result = totalCost.toFixed(2);
                    }
                }

                paymentsType[index].deposit = result;
                props.setState((prev) => {
                    return {
                        ...prev,
                        paymentsType: paymentsType,
                    };
                });
            }
        }
    };

    return (
        <div>
            {paymentsType.map((paymentsType, index) => {
                return (
                    <div key={paymentsType.type + index}>
                        <Grid
                            container
                            spacing={2}
                            sx={{ marginBottom: 1 }}
                            align="left"
                        >
                            <Grid item xs={5}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                        {t("payment_type")}
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={paymentsType.type}
                                        label="paymentsType"
                                        onChange={(event) =>
                                            handleChangePaymentMethodType(
                                                event,
                                                index
                                            )
                                        }
                                        name="paymentsType"
                                    >
                                        {getAvailablePaymentMethods(index).map(
                                            (paymentMethod, idx) => {
                                                return (
                                                    <MenuItem
                                                        value={
                                                            paymentMethod.type
                                                        }
                                                        key={idx}
                                                    >
                                                        {t(
                                                            paymentMethod.methodName
                                                        )}
                                                    </MenuItem>
                                                );
                                            }
                                        )}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl variant="standard">
                                    <InputLabel htmlFor="component-simple">
                                        {t("amount")}
                                        {CONSTANT_PAYMENT_METHODS_DICT[
                                            paymentsType.type
                                        ]?.limitToTotalPrice &&
                                            ` (max: ${
                                                props.totalCost || "0.00"
                                            })`}
                                    </InputLabel>
                                    <Input
                                        id="component-simple"
                                        value={paymentsType.deposit}
                                        onChange={(event) =>
                                            handleChangePaymentMoney(
                                                event,
                                                index
                                            )
                                        }
                                        name="deposit"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                {paymentsType.type === PaymentTypes.CASH && (
                                    <FormControl variant="standard">
                                        <InputLabel htmlFor="component-simple">
                                            {t("change")}
                                        </InputLabel>
                                        <Input
                                            id="component-simple"
                                            value={restMoney}
                                            name="changeClientMoney"
                                        />
                                    </FormControl>
                                )}
                            </Grid>
                            <Grid item xs={1}>
                                <IconButton
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    size="small"
                                    sx={{ marginTop: 3 }}
                                    onClick={() => delPaymentsMethod(index)}
                                    style={{
                                        visibility:
                                            props.paymentsType.length > 1
                                                ? "visible"
                                                : "hidden",
                                    }}
                                >
                                    <DeleteForeverOutlinedIcon />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </div>
                );
            })}
            <br />
            <br />
            {!paymentsType.some(
                (pt) => pt.type === PaymentTypes.FOOD_COUPON
            ) && (
                <Button variant="outlined" onClick={addPaymentsMethod}>
                    {t("add_payment_method_btn")}
                </Button>
            )}
        </div>
    );
}
